// Functions and Constants
import {SessionReducerType} from '../../../types/SessionTypes';
import {isSignedIn} from '../../../utils/generalUtils';

const initialState = {
  loggedIn: isSignedIn(),
};

const sessionReducer = (state = initialState, action: SessionReducerType) => {
  switch (action.type) {
    default:
      return { ...state };
  }
};

export default sessionReducer;
